export enum QuizEvent {
  INIT = "init",
  OPEN = "open",
  CLOSE = "close",
  GET_LEAD = "get_lead",
  REACH_GOAL = "reach_goal",
  LOAD_MODULE = "load_module",
}